/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Privacy_TitleInputs */

const en_wc_on_privacy_title = /** @type {(inputs: Wc_On_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your documents stay with you`)
};

/**
* | output |
* | --- |
* | "Your documents stay with you" |
*
* @param {Wc_On_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_privacy_title = /** @type {((inputs?: Wc_On_Privacy_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Privacy_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_privacy_title(inputs)
});
export { wc_on_privacy_title as "wc.on.privacy_title" }